module.exports = __webpack_public_path__ + "static/media/slide_05.4303ba76.jpg";